<template>
    <van-dropdown-item :title="title" ref="item">
        <div class="padding-left-right f14 dark-2">
            {{subTitle}}（已选 <b class="brand">{{chooseList.length}}</b> 个）
        </div>
        <van-row gutter="10" class="cl padding">
            <van-col :span="24 / rowCount" v-for="(item,index) in list" class="margin-bottom">
                <span class="tag-item block" :class="chooseList.indexOf(item[valueKey]) >= 0 ? 'on' : ''" @click="choose(item)">{{item.name}}</span>
            </van-col>
        </van-row>
        <van-button type="info" block @click="ok">确认</van-button>
    </van-dropdown-item>
</template>

<script>
export default {
    name: "DropMenu",
    data(){
        return{
            list:[],
            chooseList:[]
        }
    },
    props:{
        title:{
            type:String,
            default:'标题'
        },
        subTitle:{
            type:String,
            default:'选择行业'
        },
        valueKey:{
            type:String,
            default:'id'
        },
        valueName:{
            type:String,
            default:'name'
        },
        rowCount:{
            type:Number,
            default:4
        },
        url:{
            type:String,
            default:''
        },
        data:{
            type:[Array,Object],
            default(){
                return null
            }
        },
    },
    mounted() {
        this.getList();
    },
    watch:{
        data(n,o){
            if(JSON.stringify(n) !== JSON.stringify(o)) {
                this.getList();
            }
        }
    },
    methods:{
        getList(){
            let _this = this;
            this.$http.post({
                url:this.url,
                data:this.data,
                success(res){
                    _this.list = res;
                }
            })
        },
        choose(item){
            let _i = this.chooseList.indexOf(item[this.valueKey]);

            if(_i >= 0){
                this.chooseList.splice(_i,1);
            }else{
                this.chooseList.push(item[this.valueKey]);
            }
        },
        ok(){
            this.$refs.item.toggle();

            this.$emit('change',this.chooseList);
        }
    }
}
</script>
